module.exports = __webpack_public_path__ + "img/a4a89d7.png";